import {Text} from '#component/base';

import {CTACardNarrow} from './CTACardNarrow';

import {CTACardNarrowProps} from './CTACardNarrow.types';

import {
  accountCardBg,
  accountCardList,
  CTACardNarrowHeading,
  CTACardNarrowHeadingUpgradeAllProducts,
  CTACardNarrowLedeText,
  CTACardNarrowLedeTextUpgradeAllProducts,
  CTACardNarrowUnderstandResultsBg,
  CTACardNarrowWrapperBgMemberReferral,
  CTACardNarrowWrapperBgMemberUpgrade,
  CTACardNarrowWrapperBgPurchaseATest,
  CTACardNarrowWrapperBgUpgradeAllProducts,
  CTACardNarrowWrapperBgYourMembIsPaused,
  CTACardSurpriseByYourResultBg,
} from './CTACardNarrow.css';

export const UpgradeToMembershipNarrow = (props: CTACardNarrowProps) => (
  <CTACardNarrow
    headline="Upgrade to Membership"
    href="/profile?tab=manage"
    lede="Learn your epigenetic age, get high-quality supplements, customize your Action Plan"
    btnText="Upgrade Now"
    className={CTACardNarrowWrapperBgMemberUpgrade}
    {...props}
  />
);

export const ReferralCardUpSellNarrow = (props: CTACardNarrowProps) => (
  <CTACardNarrow
    headline="Give $30, Get $30"
    href="/shop/pages/referrals"
    lede="Longevity loves company. Refer a friend and you'll both receive a $30 credit towards your next order."
    variants="secondary"
    btnText="Refer Now"
    className={CTACardNarrowWrapperBgMemberReferral}
    {...props}
  />
);

export const YourMembershipIsPausedNarrow = (props: CTACardNarrowProps) => (
  <CTACardNarrow
    headline="Your Membership is paused"
    href="/profile?tab=manage"
    lede="When you’re ready to return, we’ll get you back on track with your testing schedule and have your Action Plans ready."
    btnText="Resume Now"
    variants="secondary"
    className={CTACardNarrowWrapperBgYourMembIsPaused}
    {...props}
  />
);
const AccountCardList = () => (
  <Text as="ul" className={accountCardList}>
    <li>
      <Text color="white">Manage your account</Text>
    </li>
    <li>
      <Text color="white">View your order history</Text>
    </li>
    <li>
      <Text color="white">Edit your address</Text>
    </li>
  </Text>
);

export const AccountCardNarrow = () => (
  <CTACardNarrow
    headline="My Account"
    href="/profile"
    lede={<AccountCardList />}
    btnText="Go to My Account"
    variants="secondary"
    className={accountCardBg}
    btnMarginTop={20}
    hasBtnIcon
    autoHeight
  />
);

export const AccountCardShippedPausedNarrow = () => (
  <CTACardNarrow
    headline="Your supplement shipments are paused"
    href="/profile?tab=manage"
    lede="When you’re ready to return, we’ll get you back on track and schedule your next order of supplements."
    btnText="Reactivate Now"
    variants="secondary"
    className={accountCardBg}
    hasBtnIcon={false}
  />
);

export const PurchaseATestNarrowCard = (props: CTACardNarrowProps) => (
  <CTACardNarrow
    headline={<HeadingPurchaseATestNarrowCard />}
    href={props.href}
    lede={<LedePurchaseATest />}
    btnText="Buy Now"
    btnColor="primary-dark"
    className={CTACardNarrowWrapperBgPurchaseATest}
    variants="textTop"
  />
);
const HeadingPurchaseATestNarrowCard = () => (
  <Text color="white" as="h2" variant="heading2" className={CTACardNarrowHeading}>
    Purchase a Test
  </Text>
);
const LedePurchaseATest = () => (
  <Text as="p" variant="body" color="white" className={CTACardNarrowLedeText}>
    {`Discover your epigenetic age`}
  </Text>
);

export const UpgradeAllProductsNarrowCard = ({ledeText}: {ledeText?: string}) => (
  <CTACardNarrow
    headline={<HeadingUpgradeAllProductsNarrowCard />}
    href="/shop/collections"
    lede={<LedeUpgradeAllProducts ledeText={ledeText} />}
    btnText="Shop Now"
    btnColor="primary"
    className={CTACardNarrowWrapperBgUpgradeAllProducts}
    variants="textBottom"
    hasBtnIcon={true}
    btnMarginTop={20}
  />
);
const HeadingUpgradeAllProductsNarrowCard = () => (
  <Text color="white" as="h2" variant="heading2" className={CTACardNarrowHeadingUpgradeAllProducts}>
    The future of healthy aging
  </Text>
);
const LedeUpgradeAllProducts = ({
  ledeText = 'Start your longevity journey.',
}: {
  ledeText?: string;
}) => (
  <Text as="p" variant="body" color="white" className={CTACardNarrowLedeTextUpgradeAllProducts}>
    {ledeText}
  </Text>
);

export const UnderstandResultsCardNarrow = ({hasLabAssessment = false}) =>
  hasLabAssessment ? (
    <CTACardNarrow
      headline="Surprised by your results?"
      href="/surprisedByYourResults"
      lede="There are many factors that influence how someone ages and we’re here to help you make sense of it."
      btnText="Learn More"
      className={CTACardSurpriseByYourResultBg}
      btnColor="primary-dark"
    />
  ) : (
    <CTACardNarrow
      headline="Understand your results"
      href="/understandingYourAge"
      lede="Learn more about your lab results and how to interpret them."
      btnText="Learn More"
      btnColor="primary-dark"
      className={CTACardNarrowUnderstandResultsBg}
    />
  );
